import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import Logo from "@/components/site/Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A1F44] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2 space-y-6">
          <Logo variant="light" />
          <p className="text-white/70 leading-relaxed max-w-md text-[15px]">
            Avvanta Advisory is a Surat-based financial and compliance firm helping businesses stay
            organized, compliant, and growth-ready. Advise. Assist. Achieve.
          </p>
          <div className="h-px w-12 bg-[#D4AF37]" />
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
            Advise · Assist · Achieve
          </p>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">Explore</h4>
          <ul className="space-y-3 text-[14px] text-white/85">
            <li><Link to="/" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-home">Home</Link></li>
            <li><Link to="/services" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-services">Services</Link></li>
            <li><Link to="/about" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-about">About</Link></li>
            <li><Link to="/insights" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-insights">Insights</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37] transition-colors" data-testid="footer-contact">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">Reach Us</h4>
          <ul className="space-y-4 text-[14px] text-white/85">
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-[3px] text-[#D4AF37]" strokeWidth={1.75} />
              <a href="tel:+917487978020" data-testid="footer-phone" className="hover:text-[#D4AF37] transition-colors">+91 74879 78020</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-[3px] text-[#D4AF37]" strokeWidth={1.75} />
              <a href="mailto:info@avvantaadvisory.com" data-testid="footer-email" className="hover:text-[#D4AF37] transition-colors break-all">info@avvantaadvisory.com</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-[3px] text-[#D4AF37]" strokeWidth={1.75} />
              <span>Surat, Gujarat, India</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[12px] text-white/55" data-testid="footer-copy">
            © {new Date().getFullYear()} Avvanta Advisory. All rights reserved.
          </p>
          <p className="text-[12px] text-white/55">
            Serving locally, supporting globally.
          </p>
        </div>
      </div>
    </footer>
  );
}
